var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "abow_dialog",
      class: _vm.className,
      style: "height: " + _vm.height + "; margin: auto 0;",
      attrs: {
        title: _vm.$t(_vm.title),
        visible: _vm.visible,
        width: _vm.width,
        "before-close": _vm.handleClose,
        "append-to-body": _vm.appendToBody,
        "close-on-click-modal": false,
        "close-on-press-escape": false
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "dialog-panel" }, [
        _c("div", { staticClass: "dialog-content" }, [_vm._t("default")], 2),
        _vm._v(" "),
        _vm.btList
          ? _c(
              "div",
              {
                staticClass: "text-center fixed-button",
                attrs: { slot: "footer" },
                slot: "footer"
              },
              [
                _vm._l(_vm.getConfigList, function(item, index) {
                  return [
                    item.show
                      ? _c(
                          "el-button",
                          {
                            directives: [{ name: "waves", rawName: "v-waves" }],
                            key: index,
                            attrs: {
                              type: item.type,
                              icon: item.icon,
                              disabled: item.disabled,
                              loading: item.btLoading
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleClick(item.event)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t(item.label)))]
                        )
                      : _vm._e()
                  ]
                })
              ],
              2
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-229ee358", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-229ee358","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog.vue
// module id = null
// module chunks = 